// レシピや献立の履歴のカルーセルを制御する
import Siema from 'siema';

const ConfiguredCarousels = [];

document.addEventListener('turbolinks:load', () => {
  const carouselContainers = document.querySelectorAll('[data-columned-carousel-wrapper]');
  if (!carouselContainers) return;

  for (let i = 0; i < carouselContainers.length; i += 1) {
    const carouselContainer = carouselContainers[i];
    const carouselBody = carouselContainer.querySelector('[data-columned-carousel]');
    const perPage = carouselBody.getAttribute('data-columned-carousel') | 0;

    const carousel = new Siema({
      selector: carouselBody,
      perPage: perPage,
      // loop: true, // Waiting for https://github.com/pawelgrzybek/siema/issues/137.
    });

    carouselContainer.querySelector('[data-carousel-step-left]').addEventListener('click', () => carousel.prev(perPage));
    carouselContainer.querySelector('[data-carousel-step-right]').addEventListener('click', () => carousel.next(perPage));

    ConfiguredCarousels.push(carousel);
  }
});

// ブラウザバック時にバグるため、遷移時にすべての設定を除去
document.addEventListener('turbolinks:request-end', () => {
  for (let i = 0; i < ConfiguredCarousels.length; i += 1) {
    ConfiguredCarousels[i].destroy(true);
  }
});
